import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { loginRequest, logout } from "../../actions/authentificationActions";
import { AppState } from "../../store/configureStore";
import { RedirectIfLoggedIn } from "./RedirectIfLoggedIn";
import { getKeycloakService } from "../../services/authenticationService";
import "./Login.css";
import { useHistory } from "react-router-dom";
import Logo from "../../images/entsoe_logo.svg";

export const Login = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const loginState = useSelector((state: AppState) => state.login);
    /*
    const [realm, setRealm] = useState("");
    */
    const [loading, setLoading] = useState(false);
    /*
    const keycloakAuthUrl = `https://keycloak.entsoe.eu/auth/realms/IMP/protocol/openid-connect/auth?client_id=${realm}&scope=openid&response_type=code&redirect_uri=${window.location.origin}/login`;

    const fetchKeycloakRealm = useCallback(async () => {
        keycloakLogout();
        setLoading(true);
        try {
            const newRealm = await getKeycloakRealm();
            if (newRealm.length === 0) console.error("Realm is not defined");
            else setRealm(newRealm);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);
    */

    useEffect(() => {
        if (window.location.search.length > 0) {
            setLoading(true);
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get("code") ?? "";
            const codeVerifier = sessionStorage.getItem("pkce_code_verifier");
            dispatch(loginRequest({ username: "", password: "", code: code, codeVerifier: codeVerifier ?? "" }));
            setLoading(false);
        }
    }, [dispatch]);

    /*
    useEffect(() => {
        if (window.location.hostname === "localhost" && window.location.pathname === "/login") {
            history.push("/login/admin");
        } else if (
            window.location.origin.includes("solutions") ||
            window.location.origin.includes("entsoe")
        )
            fetchKeycloakRealm();
    }, [history, fetchKeycloakRealm]);
    */

    const triggerLogin = async () => {
        if (window.location.hostname === "localhost" && window.location.pathname === "/login") {
            history.push("/login/admin");
        } else if (
            window.location.origin.includes("solutions") ||
            window.location.origin.includes("entsoe")
        )
            await keycloakLoginRedirect();
    };

    const keycloakLoginRedirect = async () => {
        setLoading(true);
        const code_verifier = generateCodeVerifier();
        sessionStorage.setItem("pkce_code_verifier", code_verifier);
        const code_challenge = await generateCodeChallenge(code_verifier);

        getKeycloakService()
            .then(keycloakService => {
                if (keycloakService.active && keycloakService.authorization_endpoint && keycloakService.client) {
                    const redirectUri = `${window.location.origin}/login`;
                    let scope = "openid+profile+email";
                    if (keycloakService.customScope) {
                        scope = keycloakService.customScope;
                    }
                    sessionStorage.setItem("keycloakLogoutUrl", `${keycloakService.end_session_endpoint}?client_id=${keycloakService.client}&redirect_uri=${redirectUri}`);
                    let keycloakAuthUrl = `${keycloakService.authorization_endpoint}?client_id=${keycloakService.client}&scope=${scope}&response_type=code&redirect_uri=${redirectUri}`;
                    //Additional parameters are required for Entra authorization; it should also work for Keycloak.
                    keycloakAuthUrl = keycloakAuthUrl + `&code_challenge=${code_challenge}` +
                        `&code_challenge_method=S256`;
                    window.location.replace(keycloakAuthUrl);
                }
                else {
                    setLoading(false);
                }
            })
            .catch((err: any) => console.error(err));
    };

    function generateCodeVerifier() {
        const array = new Uint32Array(56);
        window.crypto.getRandomValues(array);
        return Array.from(array, dec => ('0' + dec.toString(16)).slice(-2)).join('');
    }

    async function generateCodeChallenge(code_verifier: string | undefined) {
        const data = new TextEncoder().encode(code_verifier);
        const digest = await window.crypto.subtle.digest("SHA-256", data);
        const bytes = new Uint8Array(digest);
        let binary = '';
        for (let i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }

        const base64Digest = btoa(binary)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        return base64Digest;
    }

    if (loginState.error) {
        //clear all session storage login info and remove all URL parameters without refresh to prevent issues if user refreshes a page
        logout();
        window.history.pushState(
            null,
            '',
            window.location.pathname
        );
    }

    return (
        <div className="login-container">
            <RedirectIfLoggedIn />
            <div className="login-wrapper">
                <img src={Logo} alt="Logo" />
                <section className="login-form-container">
                    <h1 style={{ textAlign: "center" }}>Implementation Monitoring Platform</h1>
                    {!loginState.isEnabled ? (
                        <div id="login-locked-message">
                            <h4>Your account is disabled.</h4>
                            <h4>Please contact your administrator to activate your account.</h4>
                        </div>
                    ) : (
                        <>
                            <h4 id="centered-text">Please log in to your account</h4>
                            <p id="login-error-message">{loginState.error}</p>
                            <Button
                                fluid
                                primary
                                /*
                                onClick={() => window.location.replace(keycloakAuthUrl)}
                                */
                                onClick={() => triggerLogin()}
                                disabled={
                                    /*
                                    realm.length === 0 || loading || loginState.currentlySending
                                    */
                                    loading || loginState.currentlySending
                                }
                                loading={loading || loginState.currentlySending}
                                content="Log in"
                            />
                        </>
                    )}
                </section>
            </div>
        </div>
    );
};
